import DetectorInterface from "../DetectorInterface";
import Detector from '../Detector';

export default class Locale extends Detector implements DetectorInterface {

    public match(value: string): boolean {

        if (typeof value !== 'string') return false;

        return /^[A-Z]{3}-[A-Z]{2}$/ig.test(value.trim());
    }
}
